import { useTranslation } from 'react-i18next';

import { IconTypes } from '~/components/Icon/IconTypes';
import { ModalType } from '~/components/Modal/interface';
import { catalogStore } from '~/stores/CatalogStore';
import { mainStore } from '~/stores/MainStore';
import { userStore } from '~/stores/UserStore';

import { useModal } from './useModal';

export const useNotifyMe = (
  productId: number,
  sku: string,
  isBundle: boolean,
): {
  notifyMeOnClick: () => void;
  notifyMeIcon: IconTypes;
  notifyMeButtonText: string;
  btnClassName: string;
} => {
  const { t } = useTranslation();
  const { openModal } = useModal();

  let notifyMeOnClick = async () => {
    const res = await catalogStore.notifyMeStore.addNotifyMe(productId, sku);
    if (!res) {
      mainStore.pushAlert('error', t('errors:oops'));
      return;
    }
    openModal(ModalType.Subscription);
  };
  let notifyMeIcon = 'notification' as IconTypes;
  let notifyMeButtonText = t('notifyMe');
  let btnClassName = '';

  if (catalogStore.notifyMeStore.notifyMeSKUMap[productId]?.includes(sku)) {
    notifyMeOnClick = async () => {
      const res = await catalogStore.notifyMeStore.deleteNotifyMe(
        productId,
        sku,
      );
      if (!res) {
        mainStore.pushAlert('error', t('errors:oops'));
        return;
      }
      openModal(ModalType.SubscriptionOff);
    };
    notifyMeIcon = 'notification-not' as IconTypes;
    notifyMeButtonText = t('unsubscribe');
  }

  if (!userStore.isAuthorized) {
    notifyMeOnClick = async () => {
      await openModal(ModalType.Auth);
    };
  }

  if (isBundle) {
    notifyMeOnClick = async () => {};
    notifyMeIcon = 'bag' as IconTypes;
    notifyMeButtonText = t('soldOut');
    btnClassName = '_disabled';
  }

  return {
    notifyMeOnClick,
    notifyMeIcon,
    notifyMeButtonText,
    btnClassName,
  };
};
